import { QuestionCircleOutlined } from "@ant-design/icons";
import { Alert, theme, Typography } from "antd";
import { useTranslation } from "react-i18next";

const ContactUs = ({ centered = false }: { centered?: boolean }) => {
  const { token } = theme.useToken();
  const { t } = useTranslation();

  return (
    <div style={{ textAlign: centered ? "center" : "start", marginTop: token.marginSM }}>
      <Alert
        message={
          <Typography.Text
            style={{
              color: token.colorTextDescription,
              fontSize: token.fontSizeSM,
            }}
          >
            {t("forms.messages.having_questions")}{" "}
            <a
              href="https://api.whatsapp.com/send/?phone=9668004330088&text&type=phone_number&app_absent=0"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "underline" }}
            >
              {t("forms.messages.contact_customer_support")}
            </a>
          </Typography.Text>
        }
        type="info"
        showIcon
        icon={<QuestionCircleOutlined />}
      />
    </div>
  );
};

export default ContactUs;
